import styled from "styled-components";
import {flexFixedSizeItem} from "../../../../themes/architecture/css-helpers/flex";

export const VideoItemContainerDefaultBox = styled.div<{stepBackStyle: boolean;}>`
    width: 100%;
    ${flexFixedSizeItem}
    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        width: 33.33%;
        transition: transform 0.5s ease-in-out;
        transform: ${({stepBackStyle}) => stepBackStyle ? "scale(0.7)" : "scale(1)"};
    }
`;
